import type { LiveProviderProps } from 'react-live';

const theme: LiveProviderProps['theme'] = {
  plain: {
    color: 'rgba(0, 0, 0, 0.87)',
    backgroundColor: '#f3f3f3',
  },
  styles: [
    {
      types: ['comment', 'prolog', 'doctype', 'cdata'],
      style: {
        color: '#634faf',
      },
    },
    {
      types: ['punctuation'],
      style: {
        color: '#bdc3b7',
      },
    },
    {
      types: ['namespace'],
      style: {
        opacity: 0.7,
      },
    },
    {
      types: ['class-name'],
      languages: ['jsx'],
      style: {
        color: '#2577b3',
      },
    },
    {
      types: ['token', 'tag', 'operator', 'number'],
      style: {
        color: '#1b6498',
      },
    },
    {
      types: ['keyword'],
      style: {
        color: '#7b6f06',
      },
    },
    {
      types: ['property', 'function'],
      style: {
        color: '#ce5d25',
      },
    },
    {
      types: ['deleted', 'selector', 'keyword', 'tag-id', 'atrule-id', 'atrule'],
      style: {
        color: '#5f6858',
      },
    },
    {
      types: ['attr-name'],
      languages: ['jsx'],
      style: {
        color: '#3c740a',
      },
    },
    {
      types: ['token', 'string'],
      languages: ['css'],
      style: {
        color: '#2577b3',
      },
    },
    {
      types: [
        'boolean',
        'string',
        'entity',
        'url',
        'attr-value',
        'control',
        'directive',
        'unit',
        'statement',
        'regex',
        'atrule',
      ],
      style: {
        color: '#2577b3',
      },
    },
    {
      types: ['placeholder', 'variable'],
      style: {
        color: '#8dcefc',
      },
    },
    {
      types: ['important'],
      style: {
        color: '#3c740a',
      },
    },
  ],
};

export default theme;
